export default {
  // FireStoreから取得したアンカー
  anchors: [],
};
